import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=665f020c&"
import script from "./EmailTemplates.vue?vue&type=script&lang=ts&"
export * from "./EmailTemplates.vue?vue&type=script&lang=ts&"
import style0 from "./EmailTemplates.vue?vue&type=style&index=0&id=665f020c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports